import DOMPurify from "dompurify";

interface HtmlMessageProps {
  content: string;
}

export default function HtmlMessage({ content }: HtmlMessageProps) {

  // Sanitize the HTML content to prevent XSS attacks
  const sanitizedHtml = DOMPurify.sanitize(content, {
    WHOLE_DOCUMENT: true,
    ALLOWED_TAGS: [
      'html', 'head', 'body', 'meta', 'title', 'style',
      'b', 'i', 'em', 'strong', 'a', 'p', 'div', 'span', 
      'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'br',
      'table', 'thead', 'tbody', 'tr', 'th', 'td', 'img',
      '!doctype'
    ],
    ALLOWED_ATTR: [
      'href', 'class', 'style', 'src', 'alt', 'width', 'height',
      'lang', 'charset', 'name', 'content', 'viewport'
    ],
    ADD_ATTR: ['target', 'rel'],
    ADD_CLASS: ['w-full', 'border-collapse', 'bg-gray-100', 'p-2', 'border', 
                'text-green-600', 'text-yellow-600', 'container', 'emergency-section', 
                'contact-section', 'icon']
  });


  return (
    <div 
      className="html-message prose prose-sm max-w-none p-4 bg-white rounded-lg shadow-sm"
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }} 
    />
  );
}
